import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { C, cF } from '@fullcalendar/core/internal-common';
import { number } from 'echarts';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { SseService } from 'src/app/services/SseService';
import { listasServices } from 'src/app/services/listas.services';
import { MetaApiService } from 'src/app/services/meta-api.service';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { urlMercado } from 'src/app/utils/mercado-url.util';
@Component({
  selector: 'app-lista-compania',
  templateUrl: './lista-compania.component.html',
  styleUrl: './lista-compania.component.scss'
})
export class ListaCompaniaComponent implements OnInit, OnDestroy {
@Input() currentlistcfd: boolean;
@Input() metaapi: boolean;
/** Mercado de /listas del que salen las compañías seleccionadas. */
@Input() mercado: any;

  public companias = new CdkTableVirtualScrollDataSource<companiaLista>;
  public listaOriginal: companiaLista[] = [];
  displayedColumns: string[] = ['n', 'iso', 'descripcion', 'eliminar'];
  @ViewChild('listaComp', { static: false }) listaCompViewport!: CdkVirtualScrollViewport;
  public listasSub: Subscription;
  public nombreLista: string;
  public iso: string;
  public licencia: any;
  public lista = {
    idmercado: 0,
    nombre: '',
    iso: '',
    tipo: 0,
    cantidad: 0,
    userid: 0
  };
  theme: string;

  constructor(private _sseService: SseService, private _coockieService: CookieService,
    @Optional() public dialogRef: MatDialogRef<ListaCompaniaComponent>,
    private _listasService: listasServices, private cdr: ChangeDetectorRef,
    public dialog: MatDialog, private toastr: ToastrService,
    private metaApiService: MetaApiService,

  ) {

  }
  ngOnDestroy(): void {
    this.cerrarDialog();
  }

  ngOnInit(): void {
    this.licencia = this._coockieService.get('auth_token');
    this.theme = this._coockieService.get('theme');
    this.listasSub = this._listasService.vallistasCompania$.subscribe({
      next: (data: any) => {
        if (data) {
          this.listaOriginal = data;
          this.companias = new CdkTableVirtualScrollDataSource<companiaLista>(data);
          this.cdr.detectChanges();
        }
      }
    });
  }

  CrearLista() {
    if (this.iso && this.listaOriginal.length > 0) {
      const crear = (metaApiCuentaId?: number) => {
        let jsondata: any = {
          nombre: this.iso,
          iso: this.iso,
          metaapi: this.metaapi,
          sectype: this.currentlistcfd ? 'CFD' : 'STK',
        }
        if (metaApiCuentaId != null) jsondata.metaApiCuentaId = metaApiCuentaId;
        this._sseService.apiPostNew('crearlista', jsondata, this.licencia).subscribe({
          next: (data: any) => {
            this.lista = data;
            if (this.lista.idmercado > 0) {
              this.guardarLista();
            }else{
               this.toastr.error('El nombre de la lista ya existe en la base de datos', 'Error', {
                timeOut: 3000,
                positionClass: 'toast-top-right'
              });
            }
          }
        });
      };

      if (this.metaapi) {
        // Link the new market to the user's currently active MetaApi account
        // (not just "the first one") so its broker's trading-session timezone
        // can be resolved later (tbl_mercado.metaapi_cuenta_id). Falls back to
        // the first saved account if the active one isn't found (e.g. a single
        // account, or the active-account marker is stale).
        const activeAccountId = this.metaApiService.getAccountId();
        this._sseService.apiGetWithAuth('metaapi/cuentas-guardadas', this.licencia).subscribe({
          next: (data: any) => {
            const cuentas = data?.cuentas ?? [];
            const activa = activeAccountId
              ? cuentas.find((c: any) => c.metaApiAccountId === activeAccountId)
              : null;
            crear((activa ?? cuentas[0])?.id);
          },
          error: () => crear(undefined)
        });
      } else {
        crear(undefined);
      }
    } else {
      const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '200px',
        panelClass: this.theme,
        data: {
          msj: 'Debe colocar un nombre y Seleccionar Compañias'
        }
      });
    }

  }
  guardarLista() {
    let url = 'agregarcompanialista';
    let listaTransformada = this.listaOriginal.map(item => ({
      idmercado: this.lista.idmercado,
      idnectum: item['idNectum'], // Fix: use bracket notation
    }));

    this._sseService.apiPostNew(url, listaTransformada, this.licencia).subscribe({
      next: (data: any) => {
        console.log("DARA RESPONSE DSE AGREGARCOMPANIA: ", data);
        if (data.estatus) {
          this.toastr.success('Se ha Creado Lista ' + this.lista.nombre);
          
          this.cerrarDialog();
        }
      }
    });
  }
  cerrarDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    if (this.listasSub) {
      this.listasSub.unsubscribe();
    }
    this.companias = new CdkTableVirtualScrollDataSource<companiaLista>();
    this.listaOriginal = [];
  }

  actualizarViewport() {
    this.listaCompViewport.checkViewportSize();
    this.listaCompViewport.checkViewportSize();
  }

  EliminarCompania(element: companiaLista) {
    console.log("eliminar Compania: ", element);
    const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '200px',
      panelClass: this.theme,
      data: {
        msj: 'Esta Seguro de sacar la compañia ' + element.iso + ' de la lista'
      }
    }); dialogConfirm.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        const index = this.listaOriginal.indexOf(element);
        if (index > -1) {
          this.listaOriginal.splice(index, 1);
          this.companias.data = [...this.listaOriginal]; // Actualiza el dataSource
          console.log('Elemento eliminado:', element);
          console.log('Lista actualizada:', this.listaOriginal);
        } else {
          console.log('Elemento no encontrado en la lista');
        }
      } else {
        // Lógica a ejecutar si se cancela la acción
        console.log('La acción fue cancelada');
      }
    });
  }

  /** Abre el activo en /mercados dentro del mercado de origen. */
  urlMercadoActivo(element: any): string {
    return this.mercado ? urlMercado(this.mercado, element.iso ?? '') : '/mercados';
  }

}
